/**
 * Query keys factory for consistent cache management
 * Follows React Query best practices for nested key structures
 */
export const queryKeys = {
  // Data Products
  dataProducts: ['dataProducts'] as const,
  dataProduct: (id: string) => ['dataProducts', id] as const,
  dataProductReleases: (id: string) => ['dataProducts', id, 'releases'] as const,
  dataProductIssues: (id: string) => ['dataProducts', id, 'issues'] as const,
  dataProductFavorites: () => ['dataProducts', 'favorites'] as const,

  // Posts
  posts: ['posts'] as const,
  post: (id: string) => ['posts', id] as const,
  postLikes: (id: string) => ['posts', id, 'likes'] as const,
  postComments: (id: string) => ['posts', id, 'comments'] as const,
  postStats: (id: string) => ['posts', id, 'stats'] as const,

  // Subscriptions
  subscriptions: ['subscriptions'] as const,
  subscription: (id: string) => ['subscriptions', id] as const,
  subscriptionDataModels: ['subscriptionDataModels'] as const,
  subscriptionAttributes: ['subscriptionAttributes'] as const,
  subscriptionMeasures: ['subscriptionMeasures'] as const,

  // Governance
  markets: ['markets'] as const,
  divisions: ['divisions'] as const,
  filterOptions: ['filterOptions'] as const,

  // User & Access
  userRole: ['userRole'] as const,
  userAccess: ['userAccess'] as const,
  approvals: ['approvals'] as const,

  // User profiles
  userProfile: (userId: string) => ['user-profile', userId] as const,
  userProfiles: (userIds: string) => ['user-profiles', userIds] as const,

  // Catalog
  catalogScopeDimensions: (catalogId: string) => ['catalog', catalogId, 'dimensions'] as const,
} as const;